<template>
  <div class="text-center" 
       transition="fade-transition">
    
    <div class="mx-auto pt-10" 
         style="max-width:200px">
    
      <Cover :src="item.cover"/>
    
      <v-progress-linear indeterminate />
    
      <p class="text-h5 mt-2">
        {{ item.title }}
      </p>
    
    </div>
  
  </div>
</template>

<style type="text/css" scoped>
   
</style>

<script>
import Cover from '@/components/UI/Cover'

  export default {
    name: 'LoadingCover',

    mixins: [],

    components:
    {
      Cover
    },

    data: () => ({
      
    }),

    props: {
      item: {
        required: true
      }
    },

    computed: {
      
    }
  }
</script>
